
        module.exports = __webpack_public_path__ + "assets/images/cvicon.7822bd05.png";;

        var src = '' + module.exports;

        module.exports = {

            src: src,
            width: 167,
            height: 191,
            type: "png",
            bytes: 2571,

            toString: function() {
                return src;
            }
        };
    